module.exports = __webpack_public_path__ + "img/popular3.3b4553d6.png";